import { RestaurantCustomer } from "./customer";
export type BaseCustomer = {
  id: string;
  name: string | null;
  email: string;
  created_at: string;
};

export type CreateRestaurantCustomerData = {
  name: string;
  email?: string;
  phone?: string;
  birth_day_month?: string | null;
  birth_year?: number | null;
  birthday?: string;
  status_level?: string;
  tags?: string[];
};

export type UpdateRestaurantCustomerData = {
  name?: string;
  email?: string;
  phone?: string;
  birth_day_month?: string | null;
  birth_year?: number | null;
  birthday?: string | null;
  status_level?: string;
  tags?: string[];
};

export type RestaurantCustomerFilters = {
  search?: string;
  status_level?: string;
  tags?: string[];
  sort?: string;
  limit?: number;
  offset?: number;
};

export type RestaurantCustomerStats = {
  total_customers: number;
  new_customers_this_month: number;
  total_spent_all_time: number;
  average_order_value: number;
};

// Common status levels
export const CUSTOMER_STATUS_LEVELS = {
  NEW: "new",
  REGULAR: "regular",
  VIP: "vip",
  INACTIVE: "inactive",
  DELETED: "deleted",
} as const;

// Common tags
export const CUSTOMER_TAGS = {
  FREQUENT_VISITOR: "frequent_visitor",
  HIGH_SPENDER: "high_spender",
  SPECIAL_DIETARY: "special_dietary",
  BIRTHDAY_CLUB: "birthday_club",
  LOYALTY_MEMBER: "loyalty_member",
  COMPLAINT_HISTORY: "complaint_history",
  PREFERRED_SEATING: "preferred_seating",
} as const;
